import React, { useState } from 'react';
import * as PropTypes from 'prop-types';
import {
  ElementWrapper,
  InputWrapper,
  Input,
  ShowPasswordButton,
  ErrorMessageWrapper,
  ErrorMessage,
} from './elements';

function TxtField02(props) {
  const [inputSettings, setInputSettings] = useState({
    type: 'password',
    icon: 'icon-visibility',
  });

  return (
    <ElementWrapper className={props.className}>
      <InputWrapper>
        <Input
          className={props.className}
          disabled={props.disabled}
          error={props.errorMessage || props.error}
          name={props.name}
          onChange={props.onChange}
          placeholder={props.placeholder}
          type={inputSettings.type}
          defaultValue={props.defaultValue}
          value={props.value}
          min={props.min}
          max={props.max}
          step={props.step}
          accept={props.accept}
        />
        <ShowPasswordButton
          icon={inputSettings.icon}
          onClick={() => {
            if (inputSettings.type === 'password') {
              return setInputSettings({
                type: 'text',
                icon: 'icon-visibility_off',
              });
            }

            return setInputSettings({
              type: 'password',
              icon: 'icon-visibility',
            });
          }}
        />
      </InputWrapper>

      <ErrorMessageWrapper>
        <ErrorMessage errorMessage={props.errorMessage || props.error}>
          {props.errorMessage}
        </ErrorMessage>
      </ErrorMessageWrapper>
    </ElementWrapper>
  );
}

TxtField02.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  errorMessage: PropTypes.node,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.node,
};

export default TxtField02;
